import { render, staticRenderFns } from "./MaterialTemplate.vue?vue&type=template&id=472939f2&scoped=true"
import script from "./MaterialTemplate.vue?vue&type=script&lang=js"
export * from "./MaterialTemplate.vue?vue&type=script&lang=js"
import style0 from "./MaterialTemplate.vue?vue&type=style&index=0&id=472939f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472939f2",
  null
  
)

export default component.exports